import { Component, computed } from '@angular/core';

import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NavService } from '../../services/nav.service';
import { UserService } from '../../services/user.service';
import { NoAccessComponent } from '../../components/no-access/no-access.component';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    imports: [
        NgClass,
        RouterLink,
        RouterLinkActive,
        RouterOutlet,
        NoAccessComponent
    ]
})
export class LayoutComponent {
  hasAccess = computed<boolean>(() => this.userService.hasAccess());

  constructor(public navService: NavService,
    private userService: UserService
  ) {}

  logout(): void {
    this.userService.logout();
  }
}
